import { createElement, forwardRef } from 'react';
import { square } from '../patterns/square.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const Square = /* @__PURE__ */ forwardRef(function Square(props, ref) {
  const [patternProps, restProps] = splitProps(props, square.propKeys)
  const styleProps = square.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})